import { format } from "date-fns";

export interface DateWithSlots {
  value: Date;
  slots?: string[];
}

export interface AvailableDate {
  day?: string;
  name?: string;
  times?: string[];
}

export interface Month {
  num: string;
  name: string;
}

export interface Meeting {
  eventId?: string;
  title: string;
  location: string;
  locationPhone?: string;
  start: Date;
  end?: string;
  startHour: string;
  endHour: string;
  utcId?: number;
  eventTypeId?: number;
  reminderScheduleId: number;
  description: string;
  notes: string;
}

export interface CreateParticipantEventInput {
  eventId?: string;
  title: string;
  location: string;
  description: string;
  notes?: string;
  start: string;
  utcId?: number;
  eventTypeId?: number;
  reminderScheduleId?: number;
  guest: {
    guestList: {
      profileId: string;
    }[];
  };
}

export interface CreateParticipantEventResponse {
  eventId: string;
  title: string;
  location: "Zoom" | "Phone call";
  description: string;
  notes?: string;
  start: string;
  end: string;
  eventType: {
    eventTypeId: number;
    description?: string;
  };
  eventStatus: {
    eventStatusId: number;
    description?: string;
  };
  reminderScheduleId?: number;
  reminderSchedule?: {
    reminderScheduleId: number;
    description?: string;
    value?: number;
    reminderScheduleUnit?: {
      reminderScheduleUnitId: number;
      description?: string;
    };
  };
  confirmedGuest: number;
  guest: {
    profileId: string;
    guestList?: {
      guestListId: string;
      profileId: string;
      guestStatusId: number;
      confirmationDate: string;
      guestStatus: string;
    }[];
  };
  organizations?: [number];
  outlookEventId?: string;
}

export const DEFAULT_EVENT_STATE = {
  eventId: null,
  title: "",
  start: null,
  end: null,
  startHour: "",
  endHour: "",
  location: "Zoom",
  utcId: 0,
  eventTypeId: 1,
  reminderScheduleId: 1,
  description: "",
  notes: "",
  guest: {
    guestList: [],
  },
} as Meeting & CreateParticipantEventInput;

export const [monthNum, monthName] = format(new Date(), "MM MMMM").split(" ");

export const eventTypeId1v1 = 1;
export const eventStatusId = 1;

export const scheduleStates = {
  init: 0,
  add: 1,
  edit: 2,
  success: 3,
  fail: 4,
};

export const scheduleValidation = {
  dateInvalid: "Please choose your preferred meeting date",
  timeInvalid: "Please choose a time slot for the meeting",
  locationInvalid: "Please inform a valid phone number",
  descriptionInvalid: "Please describe what you would like to discuss",
};
